import $ from 'jquery'

$(document).ready(function() {
  co_team()
})

function co_team() {
  $('.co_team').each(function() {})
}
